import s from './ApplyStepIcon.module.css'

//TODO: setup proptypes
function ApplyStepIcon({ step }) {
  const icon = () => {
    switch (step) {
      case 'tick':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="51"
            height="48"
            viewBox="0 0 51 48"
            className={s.icon}
          >
            <g fill="none" fillRule="evenodd">
              <path fill="#FFF" d="M50.5 23.948L24.742 47.5H.5V.5h24.242z" />
              <circle
                cx="25.5"
                cy="24.5"
                r="9.5"
                stroke="#000"
                strokeWidth="1.5"
              />
              <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="1.5"
                d="M21 24.559l3.987 3.157L29.472 21"
              />
            </g>
          </svg>
        )
      case 'location':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="51"
            height="48"
            viewBox="0 0 51 48"
            className={s.icon}
          >
            <g fill="none" fillRule="evenodd">
              <path fill="#FFF" d="M50.5 23.948L24.742 47.5H.5V.5h24.242z" />
              <g fill="#000" fillRule="nonzero">
                <path d="M30.188 16.951a5.91 5.91 0 0 0-2.185-2.151 5.93 5.93 0 0 0-3.008-.8 5.93 5.93 0 0 0-3.009.8 5.91 5.91 0 0 0-2.185 2.151A5.692 5.692 0 0 0 19 19.913v.238c0 .075.011.119.022.151v.249c.088.8.302 1.742.659 2.821a30.927 30.927 0 0 0 1.317 3.308 75.651 75.651 0 0 0 2.943 5.718c.362.81 1.71.794 2.118 0 .46-.894.978-1.762 1.45-2.67a76.65 76.65 0 0 0 1.482-3.048 30.869 30.869 0 0 0 1.317-3.308c.358-1.082.582-2.021.67-2.821v-.152c0-.054.011-.086.022-.097v-.389c0-1.07-.275-2.054-.812-2.962zm-.396 3.156v.13c-.01.01-.022.033-.022.065v.14c-.076.768-.307 1.687-.68 2.779a32.026 32.026 0 0 1-1.373 3.34 83.505 83.505 0 0 1-2.722 5.253 68.825 68.825 0 0 1-1.274-2.335c-.43-.83-.903-1.804-1.438-2.929a31.176 31.176 0 0 1-1.362-3.33c-.373-1.091-.604-2.01-.691-2.777V20.216c-.011-.011-.022-.055-.022-.109v-.194c0-1.297.474-2.408 1.405-3.33.936-.927 2.064-1.394 3.382-1.394 1.328 0 2.456.467 3.392 1.395.93.921 1.405 2.032 1.405 3.329v.194z" />
                <path d="M24.995 18c-.549 0-1.028.2-1.417.587A1.927 1.927 0 0 0 23 20c0 .547.19 1.025.578 1.413.39.388.868.587 1.417.587s1.028-.2 1.417-.587C26.8 21.025 27 20.547 27 20s-.2-1.025-.588-1.413A1.947 1.947 0 0 0 24.995 18zm.638 2.637a.904.904 0 0 1-1.276 0 .888.888 0 0 1 0-1.264.895.895 0 0 1 1.276 0 .876.876 0 0 1 0 1.264z" />
              </g>
            </g>
          </svg>
        )
      case 'guardian':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="51"
            height="48"
            viewBox="0 0 51 48"
            className={s.icon}
          >
            <g fill="none" fillRule="evenodd">
              <path fill="#FFF" d="M50.5 23.948L24.742 47.5H.5V.5h24.242z" />
              <path
                fill="#000"
                fillRule="nonzero"
                d="M34.828 27.28A2.92 2.92 0 0 1 36 29.6v1.6a.4.4 0 0 1-.4.4h-7.2a.4.4 0 0 1-.4-.4v-1.6c0-.452.11-.893.3-1.288l-1.1-.25V31.2a.4.4 0 0 1-.4.4H16.4a.4.4 0 0 1-.4-.4v-5.075c0-1.248.79-2.373 1.988-2.788a.4.4 0 0 1 .012 0c1.311-.422 2.873-.537 3.6-.537.762 0 2.244.117 3.512.537.004.002.01 0 .013 0l4.725 1.313a2.366 2.366 0 0 1-.25-1.05c0-1.32 1.08-2.4 2.4-2.4 1.32 0 2.4 1.08 2.4 2.4 0 .959-.569 1.79-1.385 2.174l.034.017c.294.147.555.297.783.458.226.158.55.497.996 1.032zm-2.276-.84c-.37-.17-1.033-.444-1.304-.567a1.65 1.65 0 0 1-.173-.06h-.012L24.887 24.1a.4.4 0 0 1-.013 0c-1.13-.376-2.6-.5-3.275-.5-.63 0-2.182.126-3.35.5h-.012a2.134 2.134 0 0 0-1.438 2.025V30.8h9.6v-3.238a.4.4 0 0 1 .488-.387l1.9.438c.234-.249.51-.463.837-.613.004-.002.009.002.012 0 .809-.381 1.677-.6 2.363-.6.174 0 .36.014.552.04zm1.747 1.456a2.404 2.404 0 0 0-.274-.171c-.005-.003-.007-.01-.012-.013-.706-.33-1.505-.512-2.013-.512-.511 0-1.316.19-2.025.525a.4.4 0 0 1-.013 0c-.732.333-1.162 1.06-1.162 1.875v1.2h6.4v-1.2c0-.678-.335-1.283-.871-1.682l-.007.005-.023-.027zM21.6 16c1.763 0 3.2 1.437 3.2 3.2 0 1.763-1.437 3.2-3.2 3.2a3.206 3.206 0 0 1-3.2-3.2c0-1.763 1.437-3.2 3.2-3.2zm0 .8c-1.33 0-2.4 1.07-2.4 2.4 0 1.33 1.07 2.4 2.4 2.4 1.33 0 2.4-1.07 2.4-2.4 0-1.33-1.07-2.4-2.4-2.4zM32 22c-.888 0-1.6.712-1.6 1.6 0 .666.4 1.233.975 1.475l.212.063c.004 0 .01-.002.013 0a.4.4 0 0 1 .037.012c.014.003.025.01.038.013.104.02.214.037.325.037.888 0 1.6-.712 1.6-1.6 0-.888-.712-1.6-1.6-1.6z"
              />
            </g>
          </svg>
        )
      case 'consent':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="51"
            height="48"
            viewBox="0 0 51 48"
            className={s.icon}
          >
            <g fill="none" fillRule="evenodd">
              <path fill="#FFF" d="M50.5 23.948L24.742 47.5H.5V.5h24.242z" />
              <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="1.2"
                d="M15 28.79c6.555-1.164 9.832-3.663 9.832-7.497 0-5.753-3.502-4.39-4.703-3.415-1.201.976-2.056 2.548-2.444 3.624-.389 1.076-.348 2.988 0 4.243.348 1.255 1.744 5.382 5.228 5.382s2.626-1.188 3.897-1.188 1.757 1.188 3.237 1.188h5.493"
              />
            </g>
          </svg>
        )
      default:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="51"
            height="48"
            viewBox="0 0 51 48"
            className={s.icon}
          >
            <g fill="none" fillRule="evenodd">
              <path fill="#FFF" d="M50.5 23.948L24.742 47.5H.5V.5h24.242z" />
              <text fill="#000" fontFamily="Lato-Regular, Lato" fontSize="15">
                <tspan x="23" y="30">
                  {step}
                </tspan>
              </text>
            </g>
          </svg>
        )
    }
  }
  return <div className={s.container}>{icon()}</div>
}

export default ApplyStepIcon
